export default __webpack_public_path__ + "static/info-icon-083f07b1895325b78ef54210045a346e.svg";